import React, { useState, useEffect } from 'react';
import { useNotifications } from '../contexts/NotificationContext';

const ToastNotification = () => {
  const [toasts, setToasts] = useState([]);
  const { notifications, getNotificationIcon } = useNotifications();

  useEffect(() => {
    // Show toast for the latest notification
    if (notifications.length > 0) {
      const latestNotification = notifications[0];
      
      // Only show toast for unread notifications that are very recent (within last 30 seconds)
      const notificationTime = new Date(latestNotification.created_at);
      const now = new Date();
      const timeDiff = (now - notificationTime) / 1000; // in seconds
      
      if (!latestNotification.read && timeDiff < 30) {
        const toastId = Date.now();
        const newToast = {
          id: toastId,
          notification: latestNotification,
          show: true
        };
        
        setToasts(prev => [newToast, ...prev.slice(0, 2)]); // Keep only 3 toasts max
        
        // Auto remove toast after 5 seconds
        setTimeout(() => {
          setToasts(prev => prev.filter(toast => toast.id !== toastId));
        }, 5000);
      }
    }
  }, [notifications]);

  const removeToast = (toastId) => {
    setToasts(prev => prev.filter(toast => toast.id !== toastId));
  };

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-6 right-4 sm:right-6 md:right-8 z-[9999] space-y-3 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`w-[92vw] sm:w-96 md:w-[420px] bg-white shadow-lg drop-shadow-xl rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden transform transition-all duration-300 ease-in-out border border-gray-200 ${
            toast.show ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
          }`}
        >
          <div className="p-4">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <span className="text-lg">
                  {getNotificationIcon(toast.notification.notification_type)}
                </span>
              </div>
              <div className="ml-3 w-0 flex-1 pt-0.5">
                <p className="text-sm font-medium text-gray-900 break-words">
                  {toast.notification.title}
                </p>
                <p className="mt-1 text-sm text-gray-600 leading-5 break-words">
                  {toast.notification.message}
                </p>
              </div>
              <div className="ml-4 flex-shrink-0 flex">
                <button
                  className="bg-white rounded-lg inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  onClick={() => removeToast(toast.id)}
                >
                  <span className="sr-only">Close</span>
                  <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToastNotification;
